import React, { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sellernav from "../Sellernav";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Modal.css";
import toastify from "../../Util/toastify";
import BaseURL from "../../Util/BaseURL";
const Sales = () => {
  const location = useLocation();
  var nav = useNavigate();
  const updateDispatch = async (props1, props2, props3) => {
    axios.post(
      `${BaseURL}UpdateDispatch?id=${props1}&pid=${props2}`,
      {},
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    toastify("Product Dispatched", "success");
    document.getElementById(props3).style.display = "none";
  };

  const [orders, setOrders] = useState();
  async function getOrders() {
    const r = await axios.get(
      `${BaseURL}OrderItemsByProduct?name=${sessionStorage.getItem(
        "user"
      )}&id=${location.state.productId}`,
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    setOrders(r.data);
  }
  useEffect(() => {
    getOrders();
  }, []);
  function model(props, props2) {
    nav("/SellerPanel/SalesReport/Sales/DeliveryReport", {
      state: { orderno: props, pid: props2 },
    });
  }
  return (
    <>
      <Sellernav />
      <section id="hero">
        <div className="hero-container">
          <div className="hero-logo">
            <h1 className="font-weight-bold">Sales Report</h1>
          </div>
        </div>
      </section>
      <section className="">
        <div className="container">
          <div className="cart">
            <div className="table-responsive">
              <table className="table">
                <thead className="thead-dark tableH">
                  <tr>
                    <th scope="col" className="text-white">
                      Latest Orders
                    </th>
                  </tr>
                </thead>
              </table>
              <table className="table">
                <thead className="thead-dark tableH">
                  <tr>
                    <th scope="col" className="text-white">
                      Order Number
                    </th>
                    <th scope="col" className="text-white">
                      Price
                    </th>
                    <th scope="col" className="text-white">
                      Quantity
                    </th>
                    <th scope="col" className="text-white">
                      Total
                    </th>
                    <th scope="col" className="text-white">
                      Dispatch Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {orders
                    ? orders.map((data,key) =>
                        data.status === "Not Dispatched" ? (
                            <tr
                              key={key}
                              id={data.id}
                              className="target r"
                              onClick={() =>
                                model(data.ordernumber, data.product_id)
                              }
                            >
                              <td>{data.ordernumber}</td>
                              <td className="price">{data.price}</td>
                              <td className="quantity">{data.quantity}</td>
                              <td className="total">
                                {data.quantity * data.price}
                              </td>
                              <td className="total">
                                <b style={{ color: "red" }}>Not Dispatched</b>
                              </td>
                            </tr>
                        ) : (
                          <></>
                        )
                      )
                    : ""}
                </tbody>
              </table>

              <table className="table">
                <thead className="thead-dark tableH">
                  <tr>
                    <th scope="col" className="text-white">
                      Dispatched Orders
                    </th>
                  </tr>
                </thead>
              </table>
              <table className="table">
                <thead className="thead-dark tableH">
                  <tr>
                    <th scope="col" className="text-white">
                      Order Number
                    </th>
                    <th scope="col" className="text-white">
                      Price
                    </th>
                    <th scope="col" className="text-white">
                      Quantity
                    </th>
                    <th scope="col" className="text-white">
                      Total
                    </th>
                    <th scope="col" className="text-white">
                      Dispatch Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {orders
                    ? orders.map((data,key) =>
                        data.status === "Dispatached" ? (
                            <tr key={key} id={data.id} className="target">
                              <td>{data.ordernumber}</td>
                              <td className="price">{data.price}</td>
                              <td className="quantity">{data.quantity}</td>
                              <td className="total">
                                {data.quantity * data.price}
                              </td>
                              <td>
                                <b style={{ color: "green" }}>Dispatched</b>
                              </td>
                            </tr>
                        ) : (
                          <></>
                        )
                      )
                    : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <div className="App"></div>
    </>
  );
};

export default Sales;
